export const APP_BASE = '/app';

export const SPA_ROUTES = {
  LOGIN: '/login',
  FEDERATED_LOGIN: '/federated-login',
  LOGOUT: '/logout',
  FORGOT_PASSWORD: '/forgot-password',
  FORGOT_PASSWORD_CONFIRM: '/forgot-password-confirmation',
  LOCKOUT: '/lockout',
  MFA_CHALLENGE: '/mfa-challenge',
  ACCESS_DENIED: '/access-denied',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_CONFIRM: '/reset-password-confirmation',
  PASSWORD_RESET_REQUIRED: '/password-reset-required',
  CONFIRM_ACCOUNT: '/confirm-account',
  CONFIRM_ACCOUNT_REQUIRED: '/confirm-account-required',
  REGISTER: '/register',
  ERROR: '/error',
  LANGUAGE: '/language',
  BROWSER_UNSUPPORTED: '/browser-unsupported',
  MANAGE: '/manage',
  EDIT_PROFILE: '/edit-profile',
  CHANGE_PASSWORD: '/change-password',
  SET_PASSWORD: '/set-password',
  SUPPORT: '/support',
  SUPPORT_EDIT_ACCOUNT: '/support/edit-account',
  SUPPORT_FEDERATION_INVITE: '/support/federation-invite',
  APP_LAUNCHING: '/app-launching',
};
export const RAZOR_ROUTES = {
  EXTERNAL: '/Account/external',
  ADMIN: '/admin',
};

export const API_ROUTES = {
  FEDERATION_RESOLVE: '/api/federation/account/resolve',
  FEDERATION_REDIRECT: '/api/federation/account/redirect',
};
